input{padding:0 11px;border:1px solid #d9d9d9;height:32px}.glucose-submitted .glucose.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=glucose-add-edit.component-BZW5VTSL.css.map */
